import React from "react";
import { useTranslation } from "react-i18next";
import AppTable from "../../../../shared/AppTable";

function DiagnosisTable({ data, loading }) {
  const { t } = useTranslation();

  const columns = [
    { header: t("Sequence"), render: (row, index) => index + 1 },
    { header: t("Type"), field: "type" },
    {
      header: t("Code"),
      render: (row) => (
        <span className="font-semibold text-[#0070C2] text-xs">
          {row?.code || "__"}
        </span>
      ),
    },
    { header: t("Description"), field: "description" },
    {
      header: t("On Admission"),
      render: (row) => (row?.on_admission ? t("Yes") : t("No")),
    },
  ];

  return (
    <AppTable
      columns={columns}
      data={data?.data?.diagnosis || []}
      loading={loading}
      actions={false}
    />
  );
}

export default DiagnosisTable;
